import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 동적 임포트
const Payments = lazy(() => import('@/pages/payments'));
const ContestPaymentList = lazy(() => import('@/pages/payments/contest/ContestPaymentList'));
const ContestPaymentDetail = lazy(() => import('@/pages/payments/contest/ContestPaymentDetail'));
const ProgramPaymentList = lazy(() => import('@/pages/payments/program/ProgramPaymentList'));
const ProgramPaymentDetail = lazy(() => import('@/pages/payments/program/ProgramPaymentDetail'));
const StorePaymentList = lazy(() => import('@/pages/payments/store/StorePaymentList'));
const StorePaymentDetail = lazy(() => import('@/pages/payments/store/StorePaymentDetail'));

// 결제·주문 관리 라우트
export const paymentsRoutes: TypedRouteObject = {
	path: ROOTS.PAYMENTS,
	element: withSuspense(Payments),
	handle: {
		title: '결제·주문 관리',
		subTitle: '락앤런 트레일러닝 상품 전체 결제 관리'
	},
	children: [
		{
			index: true,
			element: <Navigate to="contest/list" replace />
		},
		// 대회 결제
		{
			path: paths.payments.contest.list.path,
			element: withSuspense(ContestPaymentList),
			handle: {
				title: '대회 결제 관리',
				subTitle: '락앤런 대회 결제 현황 및 관리'
			}
		},
		{
			path: paths.payments.contest.detail.path,
			element: withSuspense(ContestPaymentDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 고객향 대회 주문·결제 관리',
				subTitle: '결제 > 주문 통합 관리 > 상세 정보'
			}
		},
		// 프로그램 결제
		{
			path: paths.payments.program.list.path,
			element: withSuspense(ProgramPaymentList),
			handle: {
				title: '프로그램 결제 관리',
				subTitle: '락앤런 정기 프로그램 결제 현황 및 관리'
			}
		},
		{
			path: paths.payments.program.detail.path,
			element: withSuspense(ProgramPaymentDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 고객향 프로그램 주문·결제 관리',
				subTitle: '결제 > 주문 통합 관리 > 상세 정보'
			}
		},
		// 스토어 결제
		{
			path: paths.payments.store.list.path,
			element: withSuspense(StorePaymentList),
			handle: {
				title: '스토어 결제 관리',
				subTitle: '락앤런 스토어 상품 결제 현황 및 관리'
			}
		},
		{
			path: paths.payments.store.detail.path,
			element: withSuspense(StorePaymentDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 고객향 스토어 주문·결제 관리',
				subTitle: '결제 > 주문 통합 관리 > 상세 정보'
			}
		}
	]
};
